import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";

import * as codeActions from "../../../actions/codeActions";
import * as PtoRequestActions from "../../../actions/ptoRequestActions";
import PtoRequestService from "../../../services/ptoRequestService";

import PtoRequestForm from "./PtoRequestForm";
import HeaderWrapper from "../../common/HeaderWrapper";
import "./PtoRequestPage.scss";
import Loading from "../../common/Loading";
import PtoUserDisplay from "../components/PtoUserDisplay";
import { customToast as toast } from "../../../utils";
import AuditLogList from "../components/PtoAuditLogList";

const PtoRequestPage = ({
  codes,
  actions,
  auth,
  ptoBalance,
  isMobile,
  ...props
}) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const requestId = props.match?.params?.id;
  const adding = requestId === "add";
  const [editing, setEditing] = useState(adding);
  const [creatingPTO, setCreatingPTO] = useState(false);
  const [auditLog, setAuditLog] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (requestId && !adding)
        try {
          setLoading(true);
          const result = await PtoRequestService.getPtoRequest(requestId);
          setData(result);
          setAuditLog(result.audit_log);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toast.error(err.message);
        }
    };
    fetchData();
    if (!codes.length) {
      actions.loadCodes();
    }
  }, [requestId, adding, codes, actions, setLoading]);

  useEffect(() => {
    if (!ptoBalance) {
      actions.getPtoRequestBalance(auth.user._id);
    }
  }, [actions, ptoBalance, auth]);

  const onClickEdit = () => {
    setEditing((prev) => !prev);
  };

  const handleSubmit = async (request) => {
    setCreatingPTO(true);
    request.start_date = moment(request.start_date).toDate();
    request.end_date = moment(request.end_date).toDate();

    request.days = request.days.map((item) => ({
      ...item,
      date: new Date(item.date).setUTCHours(13)
    }));

    if (adding) {
      await actions.createPtoRequest(request);
    } else {
      delete request.audit_log;
      const result = await actions.updatePtoRequest(request);
      setAuditLog(result.audit_log);
    }
    setCreatingPTO(false);
  };

  const handleDelete = async (e) => {
    setLoading(true);
    e.preventDefault();
    e.stopPropagation();
    await actions.deletePtoRequest(data._id);
    props.history.push("/app/pto");
    setLoading(false);
  };

  const canEditReserved =
    data?.status?.order === 3 &&
    (auth?.user?._id === data?.manager || auth?.maxRole === 9000);

  return (
    <div>
      <HeaderWrapper breadcrumbs={[{ label: "Personal Time" }]} />
      <PtoUserDisplay data={ptoBalance} />
      <HeaderWrapper
        breadcrumbs={[{ label: `${adding ? "Add " : ""}PTO Request` }]}
        onClickEdit={
          !adding && data.status && (data.status.order === 1 || canEditReserved)
            ? onClickEdit
            : null
        }
      />
      {loading && (
        <div className="loading-loader-load-container">
          <Loading active />
        </div>
      )}
      {!loading && (
        <div className="content-wrapper">
          <PtoRequestForm
            adding={adding}
            editing={editing}
            request={data}
            codes={codes}
            history={props.history}
            handleSubmit={handleSubmit}
            handleDelete={handleDelete}
            auth={auth}
            creatingPTO={creatingPTO}
            isEditingReserved={canEditReserved}
          />
        </div>
      )}
      <div>
        <HeaderWrapper
          breadcrumbs={[{ label: "Audit Log" }]}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <AuditLogList data={auditLog} isMobile={isMobile} />
        </div>
      </div>
    </div>
  );
};

PtoRequestPage.propTypes = {
  match: PropTypes.object,
  codes: PropTypes.array,
  actions: PropTypes.object,
  history: PropTypes.object,
  auth: PropTypes.object,
  ptoBalance: PropTypes.object,
  isMobile: PropTypes.bool
};
PtoRequestPage.defaultProps = {
  codes: []
};
function mapStatesToProps(state) {
  return {
    codes: state.reducers.codes,
    ptoBalance: state.reducers.ptoBalance
  };
}
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...codeActions,
      ...PtoRequestActions
    },
    dispatch
  )
});
export default connect(mapStatesToProps, mapDispatchToProps)(PtoRequestPage);

// export default PtoRequestPage;
